import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Revenue } from "../model/Entities/Revenue";

@Injectable()
export class RevenueService extends ApiService<any> {
    protected apiUrl = "api/revenue";

    protected getObjectType(): any {
        return Revenue;
    }
}



// WEBPACK FOOTER //
// /app/src/services/revenue.service.ts